import { Component, signal} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { BearerToken } from '../../core/models/bearer-token';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {

  loggingIn = false;
  errorCode : string | undefined;
  errorMessage: string | undefined;
  loginFormSubmitted: boolean  = false;

  loginForm = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    twofactorcode: new FormControl(''),
    termsAndConditions: new FormControl(false, Validators.requiredTrue),
  });

  constructor(private authService : AuthService, private router: Router, private modalService: ModalService) {
    this.authRedirect();
  }

  authRedirect(){
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['home']);
    }
    else if (this.authService.isPartiallyLoggedIn()) {
      this.router.navigate(['mfa']);
    }
  };

  openDataSecurityAndPrivacyDialog() {
    this.modalService.showSecurityPrivacyCookiePolicyModal();
  }

  openTermsAndConditionsDialog() {
    this.modalService.showTermsAndConditionsModal();
  }

  login() {

    this.loginFormSubmitted = true;
    if (this.loginForm.invalid) return;
    this.loggingIn = true;

    var username = this.loginForm.value.username ?? '';
    var password = this.loginForm.value.password ?? '';

    // Redirect to home or show error message

    this.authService.login(username, password).subscribe({
      next: bearerToken => {
        this.authRedirect();
        this.loggingIn = false;
      },
      error: error => {
        // if the error is a 400 and can be cast to BearerToken, show the error_description
        // otherwise show a generic error message
        if (error.status === 400) {
          var bearerToken = error.error as BearerToken;
          this.errorMessage = bearerToken.error_description;
          this.errorCode = bearerToken.error;
        } else {
          this.errorMessage = 'An error occurred while trying to log in. Please try again later.';
        }
        this.loggingIn = false;
      }
    });
  }


  // Password visibility toggle
  hidePassword = signal(true);
  togglePasswordVisibility(event: MouseEvent){
    this.hidePassword.set(!this.hidePassword());
    event.stopPropagation();
  }

}
